import "#legacy/shared/sparkle_namespace.js";
import "#legacy/admin/components/spotlight_search.js";

window.SitewideSearch = function (autocompleteUrl, options) {
  jQuery.when().then(function () {
    options = jQuery.extend(
      {
        input: options.queryInput,
        details: false,
        status: false,
        matchWidth: true,
      },
      options,
    );

    var autocomplete = new Sparkle.SpotlightSearch("/sitewide_searches/autocomplete.json", options).render();

    jQuery(autocomplete.input).on("input", function (event) {
      if (jQuery.trim(this.value)) {
        jQuery(document).trigger("autocomplete.sparkle", ["sitewide", this.value]);
      }
    });

    jQuery(autocomplete).on("select", function (event, item) {
      jQuery(document).trigger("autocomplete-select.sparkle", [
        "sitewide",
        this.input.val(),
        item.url,
        item.type,
        item.id,
      ]);
      window.location = item.url;
    });
  });
};
